var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "#F4F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8889 26.3889H32V31.7222C32 32.2111 31.8261 32.6298 31.4782 32.9782C31.1304 33.3267 30.7117 33.5006 30.2222 33.5H24.8889V26.3889ZM24.8889 24.6111V17.5H30.2222C30.7111 17.5 31.1298 17.6742 31.4782 18.0227C31.8267 18.3711 32.0006 18.7895 32 19.2778V24.6111H24.8889ZM23.1111 24.6111H16V19.2778C16 18.7889 16.1742 18.3705 16.5227 18.0227C16.8711 17.6748 17.2895 17.5006 17.7778 17.5H23.1111V24.6111ZM23.1111 26.3889V33.5H17.7778C17.2889 33.5 16.8705 33.3261 16.5227 32.9782C16.1748 32.6304 16.0006 32.2117 16 31.7222V26.3889H23.1111Z",
    fill: "#00B1B2",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.6be992328005051943ae13b02553e8ef.svg";
export { ForwardRef as ReactComponent };